import Vue, { VueConstructor } from 'vue';
import { ComponentStore } from 'stores/type/type';

// tslint:disable-next-line variable-name
const VueInstance = new Vue();
type VueType = typeof VueInstance;
type Keys = Exclude<keyof VueType, '$store'>;
export type CustomVueType = { [K in Keys]: VueType[K] } & ComponentStore;
export type CustomVueConstructor<T = {}> = VueConstructor<CustomVueType & T>;

export {
  VueConstructor,
};
// tslint:disable-next-line variable-name
export const VueCustom = Vue as CustomVueConstructor;
